module.exports = __webpack_public_path__ + "img/capa2.eb4a8680.webp";